import { AbstractControl } from '@angular/forms';

export abstract class OverlayDialogFormContent<T = unknown> {
    public abstract readonly form: AbstractControl<unknown, T>;
}
